/**
 * @module project/components/participate_form/info_form_image
 */
import React, { PropTypes, Component } from 'react';
import { MoneyInputField } from 'common/components/form_fields';

/**
 * Participate info step form for image entries
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const InfoFormImage = (props) => {
  const { entry, updateDescription, setLicensingType,
    setLicensingAssets, updateFonts, updateImages } = props;

  return (
    <div className="medium-12 column participate-fields">
      <fieldset>
        <h3>Add a Description</h3>
        <p>The description helps the client understand the rationale for your design.
          Designs with meaningful descriptions win 30% more than those without.</p>
        <textarea
          name="entry_description"
          id="id_entry_description"
          className="form-control"
          onChange={updateDescription}
          value={entry.description}
        ></textarea>
      </fieldset>
      <fieldset>
        <h3>Disclosures</h3>
        <ul>
          <li>
            <div className="radio">
              <input
                id="is_original"
                type="radio"
                className="form-control"
                onClick={() => { setLicensingType('original'); }}
                checked={entry.licensing.type === 'original'}
              />
              <label
                htmlFor="is_original"
                className="form-label"
              >Everything in my entry is entirely original.</label>
            </div>
          </li>
          <li>
            <div className="radio">
              <input
                id="has_stocks"
                type="radio"
                className="form-control"
                onClick={() => { setLicensingType('partial'); }}
                checked={entry.licensing.type === 'partial'}
              />
              <label
                htmlFor="has_stocks"
                className="form-label"
              >This entry includes elements that are free or that the client will need to purchase
               (the prices are below).</label>
            </div>
            { entry.licensing.type === 'partial' &&
              <ul className="participate-licensing-list">
                <li>
                  <div className="checkbox">
                    <input
                      id="font_assets"
                      type="checkbox"
                      className="form-control"
                      onChange={() => { setLicensingAssets('fonts'); }}
                      checked={entry.licensing.assetTypes.fonts}
                      disabled={entry.licensing.type !== 'partial'}
                    />
                    <label htmlFor="font_assets" className="form-label">{"Font(s)"}</label>
                  </div>
                  {(entry.licensing.assetTypes.fonts && entry.licensing.type === 'partial') &&
                    <MoneyInputField
                      meta={{}}
                      label="Estimated Cost"
                      name="font_cost"
                      input={{
                        value: entry.licensing.assetValues.fonts,
                        placeholder: `$`,
                        name: '',
                        onChange: updateFonts
                    }}/>
                  }
                </li>
                <li>
                  <div className="checkbox">
                    <input
                      id="image_assets"
                      type="checkbox"
                      className="form-control"
                      onChange={() => { setLicensingAssets('images'); }}
                      checked={entry.licensing.assetTypes.images}
                      disabled={entry.licensing.type !== 'partial'}
                    />
                    <label htmlFor="image_assets" className="form-label">Image(s)</label>
                  </div>

                  {(entry.licensing.assetTypes.images && entry.licensing.type === 'partial') &&
                    <MoneyInputField
                        meta={{}}
                        label="Estimated Cost"
                        name="font_cost"
                        input={{
                          value: entry.licensing.assetValues.images,
                          placeholder: `$`,
                          name: '',
                          onChange: updateImages
                    }}/>
                  }
                </li>
              </ul>
            }
          </li>
        </ul>
      </fieldset>
    </div>
  );
};

/**
 * PropTypes.
 *
 * @property {object} entry - local entry data object
 * @property {func} updateDescription - update local entry description
 * @property {func} setLicensingType - update local entry licensing type
 * @property {func} setLicensingAssets - update local entry licensing assets
 * @property {func} updateFonts - update local entry licensing fonts
 * @property {func} updateImages - update local entry licensing assets
 */
InfoFormImage.propTypes = {
  entry: PropTypes.object,
  updateDescription: PropTypes.func,
  setLicensingType: PropTypes.func,
  setLicensingAssets: PropTypes.func,
  updateFonts: PropTypes.func,
  updateImages: PropTypes.func,
};

export default InfoFormImage;



// WEBPACK FOOTER //
// ./project/components/participate_form/info_form_image.jsx